<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :aid="componentParams.aid">
        </component>
    </div>
</template>
<script>
// 导入订单列表和详情组件
import PurchaseOrderList from './purchaseOrder/purchaseOrderList.vue'
import PurchaseOrderDetail from './purchaseOrder/purchaseOrderDetail.vue'

export default {
    name: 'PurchaseQuotes',
    components: {
        PurchaseOrderList,
        PurchaseOrderDetail
    },
    data() {
        return {
            currentComponent: 'purchaseOrderList', // 默认显示订单列表
            componentParams: {
                aid: ''
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'purchaseOrderList';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                // 如果切换到列表组件，重置aid
                if (componentName === 'purchaseOrderList') {
                    this.componentParams = { 
                        ...this.componentParams, 
                        ...params,
                        aid: '' // 重置aid
                    };
                } else {
                    this.componentParams = { ...this.componentParams, ...params };
                }
            }
            this.currentComponent = componentName;
        }
    }
}
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>